import React from 'react';

const TONES = {
  default: 'text-white',
  brand:   'text-brand-200',
  success: 'text-emerald-300',
  danger:  'text-red-300',
  info:    'text-sky-300',
  warn:    'text-amber-300',
};

const ICON_TONES = {
  default: 'bg-white/[0.05] border-white/[0.08] text-gray-400',
  brand:   'bg-brand-500/12 border-brand-400/25 text-brand-200',
  success: 'bg-emerald-500/12 border-emerald-500/25 text-emerald-300',
  danger:  'bg-red-500/12 border-red-500/25 text-red-300',
  info:    'bg-sky-500/12 border-sky-500/25 text-sky-300',
  warn:    'bg-amber-500/12 border-amber-500/25 text-amber-300',
};

/**
 * Egy szám + felirat + ikon. Az `icon` nyers SVG path(-ok), nem teljes <svg>,
 * hogy a méret és a vonalvastagság minden kártyán ugyanaz legyen.
 */
export default function StatCard({ label, value, icon, tone = 'default' }) {
  return (
    <div className="card card-interactive p-5">
      <div className="flex items-start justify-between gap-3 mb-3">
        <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider leading-tight">
          {label}
        </span>
        {icon && (
          <span className={`flex-shrink-0 w-8 h-8 rounded-lg border flex items-center justify-center
                            ${ICON_TONES[tone] || ICON_TONES.default}`}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"
                 strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
              {icon}
            </svg>
          </span>
        )}
      </div>
      <p className={`font-display text-2xl font-bold tabular-nums ${TONES[tone] || TONES.default}`}>
        {value}
      </p>
    </div>
  );
}

/** Gyakran használt ikonok a statisztika-kártyákhoz. */
export const STAT_ICONS = {
  users:    <><path d="M17 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" /><circle cx="9.5" cy="7" r="4" /><path d="M22 21v-2a4 4 0 00-3-3.9" /></>,
  check:    <><circle cx="12" cy="12" r="9" /><path d="M8.5 12.5l2.5 2.5 4.5-5" /></>,
  sparkle:  <><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" /><path d="M18 16l.9 2.1L21 19l-2.1.9L18 22l-.9-2.1L15 19l2.1-.9z" /></>,
  money:    <><circle cx="12" cy="12" r="9" /><path d="M12 7v10M9.5 9.5c0-1.1 1.1-2 2.5-2s2.5.7 2.5 1.75-1.1 1.75-2.5 1.75-2.5.8-2.5 1.9S10.9 15 12.3 15s2.4-.6 2.4-1.5" /></>,
  snow:     <><path d="M12 2v20M5 7l7-5 7 5M5 17l7 5 7-5M2 12h20M5 7l7 5-7 5M19 7l-7 5 7 5" /></>,
  ban:      <><circle cx="12" cy="12" r="9" /><path d="M5.6 5.6l12.8 12.8" /></>,
  key:      <path d="M15 7a5 5 0 11-4.9 6H7v3H4v-3l-1-1 1-1h6.1A5 5 0 0115 7z" />,
  chart:    <><path d="M3 3v18h18" /><path d="M7 15l4-5 3 3 5-7" /></>,
  eye:      <><path d="M3 12s3.6-7 9-7 9 7 9 7-3.6 7-9 7-9-7-9-7z" /><circle cx="12" cy="12" r="2.5" /></>,
  page:     <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><path d="M14 2v6h6" /></>,
};
